<template>
  <div class="popup-wrapper" @click.self="close">

    <!-- マイリンク追加 -->
    <transition name="popup">
      <PCMyLinkCreate
        v-if="group1.visibleMyLinkCreate"
        @loadMyLink="group1.loadMyLink"
        @closeMyLinkCreate="group1.visibleMyLinkCreate = false"
      />
    </transition>

    <!-- マイリンク編集 -->
    <transition name="popup">
      <PCMyLinkEdit
        v-if="group1.visibleMyLinkEdit"
        :myLinkTargetParams="{id: group1.myLinkTargetId, title: group1.myLinkTargetTitle, url: group1.myLinkTargetURL, newWindow: group1.myLinkTargetNewWindow}"
        @loadMyLink="group1.loadMyLink"
        @closeMyLinkEdit="group1.visibleMyLinkEdit = false"
      />
    </transition>

    <!-- マイリンク並び替え -->
    <transition name="popup">
      <PCMyLinkChangePosition
        v-if="group1.visibleMyLinkChangePosition"
        :myLinkParams="{id: group1.myLinkTargetId, list: group1.list}"
        @loadMyLink="group1.loadMyLink"
        @closeMyLinkChangePosition="group1.visibleMyLinkChangePosition = false"
      />
    </transition>

    <!-- マイリンク削除確認 -->
    <transition name="popup">
      <PCMyLinkDeleteConfirm
        v-if="group1.visibleMyLinkDeleteConfirm"
        :myLinkTargetParams="{id: group1.myLinkTargetId}"
        @loadMyLink="group1.loadMyLink"
        @closeMyLinkDeleteConfirm="group1.visibleMyLinkDeleteConfirm = false"
      />
    </transition>

    <div class="popup-container lg">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <p class="hdg02 mb24">マイリンク</p>
          <p class="txt-sup mb0">マイリンクは10件まで登録できます。</p>
        </div>
        <div class="popup-content">
          <div class="popup-content-hdg">
            <p class="hdg03 line mb0">マイリンク</p>
            <span class="link" role="button"
              v-if="group1.isAddButtonShown"
              @click="group1.openMyLinkCreate"
            >マイリンクの追加</span>
          </div>
          <div class="popup-content-box">
            <ul class="list">

              <li v-for="(item, index) in group1.list" :key="'mylink_' + index">
                <div class="detail">
                  <p class="title">{{ item.title }}</p>
                  <p class="link">
                    <span class="link-text">{{ item.url }}</span>
                    <span v-if="item.new_window === 1" class="link-type">別窓</span>
                  </p>
                </div>
                <div class="edit" @click="group1.openMyLinkEdit({id: item.id, title: item.title, url: item.url, newWindow: item.new_window})">
                  <ButtonEdit />
                </div>
                <div class="control">
                  <div class="transition" role="button"
                    @click="group1.openMyLinkChangePosition({id: item.id})"
                    >
                    <ButtonChangePosition />
                  </div>
                  <div @click="group1.openMyLinkDeleteConfirm({id: item.id})"><ButtonClose/></div>
                </div>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'

import PCMyLinkCreate from '@/components/pc/popup/PCMyLinkCreate.vue'
import PCMyLinkEdit from '@/components/pc/popup/PCMyLinkEdit.vue'
import PCMyLinkChangePosition from '@/components/pc/popup/PCMyLinkChangePosition.vue'
import PCMyLinkDeleteConfirm from '@/components/pc/popup/PCMyLinkDeleteConfirm.vue'

import * as logicMyLinkList from '@/logic/dashboard/MyLinkList'

export default defineComponent({
  components: {
    PCMyLinkCreate,
    PCMyLinkEdit,
    PCMyLinkChangePosition,
    PCMyLinkDeleteConfirm
  },
  props: {
    parentMyLinkList: {
      type: Array,
      required: true
    }
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicMyLinkList.getGroup(props, context)

    const close = () => {
      context.emit('closeMyLinkList')
    }

    return {
      group1,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  &-content {
    background-color: $color-bg-form;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    &-hdg {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      .hdg03 {
        width: calc(100% - 130px);
        padding-right: 20px;
      }
      .link {
        display: block;
        width: 130px;
        color: $color-link;
        font-size: 1.6rem;
      }
    }
    &-box {
      .list {
        list-style: none;
        background-color: #fff;
        border-radius: 8px;
        border: 1px solid $color-line;
        li {
          padding: 20px 12px 20px 40px;
          display: flex;
          align-items: center;
          .detail {
            width: calc(100% - 188px);
            .title {
              font-size: 2.0rem;
              color: $color-hdg;
              font-weight: bold;
              margin-bottom: 10px;
            }
            .link {
              color: $color-sup;
              font-size: 1.3rem;
              &-title,
              &-type {
                display: inline-block;
              }
              &-type {
                margin-left: 20px;
              }
            }
          }
          .edit {
            width: 134px;
            padding-left: 20px;
            padding-right: 10px;
            .icn {
              margin-right: 10px;
              font-size: 2.0rem;
            }
          }
          .control {
            display: flex;
            align-items: center;
          }
          & + li {
            border-top: 1px solid $color-line;
          }
        }
      }      
    }
  }
}
</style>
